/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import FeedbackPopUp from 'components/Feedback/FeedbackPopUp/index';
import TimezoneChoicePopUp from 'components/UserAccount/Confirms/ConfirmNoticeBlocks/TimezoneChoicePopUp/index';
import RulesOfRatingPopUp from 'components/Rating/StatusesDescTable/RulesOfRatingPopUp';
import FagContentItemPopUp from 'components/FaqContents/FagContentItemPopUp';
import InfoMaterialPopUp from 'components/InfoMaterials/InfoMaterialPopUp';
import ComplaintReportPopUpForComment from 'components/Complaints/ComplaintReportPopUpForComment/index';
import ComplaintReportPopUpForTask from 'components/Complaints/ComplaintReportPopUpForTask/index';
import GeoTargetIsAccessPopUp from 'components/Tasks/_common/CheckGeotargetAccess/GeoTargetIsAccessPopUp';
import MessengerGroupRoomFormPopUp from 'components/Messenger/content/MessengerGroupRoomFormPopUp';
import TimeTargetOptionsNewPopUp from 'components/Tasks/_common/TimeTargetOptionsNewPopUp';

import CSSTransition from 'react-transition-group/CSSTransition';
import qs from 'qs';

const popUpsLocationHashMap = [
  {
    hash: '#pop-up/feedback',
    component: FeedbackPopUp,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/choiceTimezone',
    component: TimezoneChoicePopUp,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/userPointsTypes',
    component: RulesOfRatingPopUp,
    class: 'modal modal-header-info fade'
  },
  {
    hash: '#pop-up/fagContent',
    component: FagContentItemPopUp,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/infoMaterials',
    component: InfoMaterialPopUp,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/commentComplaint',
    component: ComplaintReportPopUpForComment,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/taskComplaint',
    component: ComplaintReportPopUpForTask,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/checkGeoTarget',
    component: GeoTargetIsAccessPopUp,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/getTimeTarget',
    component: TimeTargetOptionsNewPopUp,
    class: 'modal modal-gray fade'
  },
  {
    hash: '#pop-up/messengerGroupRoomFormPopUp',
    component: MessengerGroupRoomFormPopUp,
    class: 'modal modal-gray fade'
  }
];

class GlobalPopUps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasShow: false,
      component: null,
      props: {}
    };
  }

  componentDidMount() {
    if (this.props.location.hash !== '') {
      this.changeStateFromLocationHash();
    }
  }

  componentDidUpdate(prevProp) {
    if (prevProp.location.hash !== this.props.location.hash) {
      this.changeStateFromLocationHash();
    }
  }

  changeStateFromLocationHash = () => {
    if (
      this.props.location.hash !== '' &&
      this.props.location.hash.includes('#pop-up')
    ) {
      const hashSplit = this.props.location.hash.split('?');
      const hashName = hashSplit[0];
      const hashParams = qs.parse(hashSplit[1]);
      for (let i = 0; i < popUpsLocationHashMap.length; i += 1) {
        const item = popUpsLocationHashMap[i];
        if (item.hash === hashName) {
          this.setState({
            hasShow: true,
            component: item.component,
            class: item.class,
            props: hashParams
          });
          break;
        }
      }
    } else {
      this.setState({
        hasShow: false
      });
    }
  };

  handleClose = event => {
    if (event) {
      event.preventDefault();
    }
    if (this.props.history.length > 2) {
      this.props.history.goBack();
    } else {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: this.props.location.search
      });
    }
  };
  render() {
    const LocationHashPopUp = this.state.component;
    return (
      <CSSTransition
        in={this.state.hasShow}
        classNames=""
        timeout={500}
        unmountOnExit
        onEnter={() => {
          // eslint-disable-next-line no-undef
          $(`#locationHashPopUp`).modal('show');
        }}
        onExiting={() => {
          // eslint-disable-next-line no-undef
          $(`#locationHashPopUp`).modal('hide');
        }}
        onExited={() => {
          // eslint-disable-next-line no-undef
          this.setState({
            hasShow: false
          });
        }}
      >
        <div
          key={`locationHashPopUp`}
          id={`locationHashPopUp`}
          className={this.state.class}
          role="dialog"
          tabIndex="-1"
          onClick={e => {
            this.handleClose(e);
          }}
        >
          {LocationHashPopUp !== null ? (
            <LocationHashPopUp
              {...{ ...this.props, ...this.state.props }}
              handleClose={this.handleClose}
            />
          ) : null}
        </div>
      </CSSTransition>
    );
  }
}

GlobalPopUps.propTypes = {
  // withRouter
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func,
    length: PropTypes.number
  }).isRequired
};

export default withRouter(GlobalPopUps);



// WEBPACK FOOTER //
// ./src/components/Common/GlobalPopUps/GlobalPopUps.js